import { render, staticRenderFns } from "./MinusButton.vue?vue&type=template&id=8f41dc0c&scoped=true&"
import script from "./MinusButton.vue?vue&type=script&lang=ts&"
export * from "./MinusButton.vue?vue&type=script&lang=ts&"
import style0 from "./MinusButton.vue?vue&type=style&index=0&id=8f41dc0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f41dc0c",
  null
  
)

export default component.exports